import React from 'react';
import { HTMLTrans } from '../Common/Translations';
import { willShowModal } from '../Common/Modal/Modal';
import { compose, withHandlers, withPropsOnChange, withState } from 'recompose';
import config from '../../config';
import { connectUserHeaderinfo } from './WithUserHeaderInfo';
import { showErrorMsg } from '../Common/ErrorMsg';

const ChangePasswordModal = ({
  userHeaderInfo,
  onChangePassword,
  setCurrentPassword,
  setPassword,
  setPasswordConfirmation,
  onSubmitPassword,
  disableButton,
}) => (
  <div className="bg-white ">
    <div className="modal-header pb-0">
      <h3 className="text-primary font-weight-bold"><HTMLTrans
        id='account.personalinfo_changepassword_title'>Change Password</HTMLTrans></h3>
      <button type="button" className="close" data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div className="modal-body pt-0">
      <div className="row">
        <div className="col m-3">
          <div className="form-group">
            {(!(userHeaderInfo.isSignedUpViaSocial) || userHeaderInfo.passwordWasResetBefore) &&
            <div>
              <label htmlFor="reset-password-password" className="text-primary font-weight-bold">
                <HTMLTrans id='account.personalinfo_changepassword_current_password_label'>Current password</HTMLTrans>
              </label>
              <input type="password" id="change-password-current-password" className="form-control mb-3" onChange={e => onChangePassword(e, setCurrentPassword)}/>
            </div>
            }
            <label htmlFor="reset-password-password" className="text-primary font-weight-bold">
              <HTMLTrans id='account.personalinfo_changepassword_password_label'>New password</HTMLTrans>
            </label>
            <input type="password" id="reset-password-password" className="form-control mb-3" onChange={e => onChangePassword(e, setPassword)}></input>
            <label htmlFor="reset-password-password-confirmation" className="text-primary font-weight-bold">
              <HTMLTrans id='account.personalinfo_changepassword_retype_password_label'>Retype password</HTMLTrans>
            </label>
            <input type="password" id="reset-password-password-confirmation" className="form-control" onChange={e => onChangePassword(e, setPasswordConfirmation)}></input>
            <div className="text-center mt-3">
              <button disabled={!disableButton} id="reset-password-submit" className='btn btn-block btn-md btn-primary' type="button" onClick={onSubmitPassword}>
                <HTMLTrans id='account.personalinfo_change_password_submit_button'>Change Password</HTMLTrans>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);
const EnhancedChangePasswordModal = compose(
  connectUserHeaderinfo,
  withState('currentPassword', 'setCurrentPassword', ''),
  withState('password', 'setPassword', ''),
  withState('passwordConfirmation', 'setPasswordConfirmation', ''),
  withState('disableButton', 'setDisableButton', false),
  withPropsOnChange(['password', 'passwordConfirmation', 'setDisableButton'], ({ password, passwordConfirmation, setDisableButton }) => {
    setDisableButton(password === passwordConfirmation && password.length > 1);
  }),
  withHandlers({
    onSubmitPassword: ({ currentPassword, password, passwordConfirmation, closeModal }) => () => {
      const params = {
        existing_password: currentPassword,
        password,
        password_confirmation: passwordConfirmation,
      };
      $.post(`${config.localeApi}/userprofilechangepassword`, params)
        .done((response) => {
          toastr.success(
            response.data, '',
            { positionClass: 'toast-bottom-full-width' },
          );
          closeModal();
        })
        .fail(({ responseJSON: { errors = '' } }) => {
          showErrorMsg(errors);
        });
    },
    onChangePassword: () => (e, func) => func(e.target.value),
  }),
)(ChangePasswordModal);
const ChangePasswordButton = (props) => (
  <button type="button" className="btn change-password">
    <HTMLTrans id="account.changepassword_button">Change Password</HTMLTrans>
    {props.children}
  </button>
);
const hasChangePasswordModal = (comp) => {
  const Modal = willShowModal({ size: 'xs' })(comp);
  return props => (
    (
      <Modal>
        {closeModal => (<EnhancedChangePasswordModal closeModal={closeModal} {...props}/>)}
      </Modal>
    )
  );
};
export default hasChangePasswordModal(ChangePasswordButton);



// WEBPACK FOOTER //
// ./src/Auth/ChangePassword.js